import {autorun} from 'mobx';

import {ACTION_TYPES, ROUTE_NAMES} from "../../../../../core/consts";
import {EntitiesDomainService} from "../../../../../domain/entities/services/entities.domain-service";
import {EntitiesRequestParams} from "../../../../../domain/entities/models/entities.request-params";
import {EntitiesResponseDomainModel} from "../../../../../domain/entities/models/entities.response-domain-model";
import {FetchHandler} from "../../../../../infrastructure/handlers/fetch-handler";
import {ModuleController} from "../../../../../infrastructure/controllers/module-controller";
import {WebsiteModuleState} from "../../../models/website-module.state";
import {EntityHeaderModuleState} from "../models/entity-header-module.state";

export class EntityHeaderFetchHandler extends FetchHandler {
  controller: ModuleController;
  state: EntityHeaderModuleState;

  static injectables = [EntitiesDomainService, WebsiteModuleState];

  constructor(service: EntitiesDomainService, websiteModuleState) {
    super(service);

    this.websiteModuleState = websiteModuleState;
  }


  async onLoaded() {
    await super.onLoaded();

    const relevantRoutes = [ROUTE_NAMES.competitionScores, ROUTE_NAMES.competitorScores, ROUTE_NAMES.game];

    autorun(() => this.state.currentLinkModel && relevantRoutes.includes(this.state.currentLinkModel.name) && this.action())
  }

  get requestParams(): EntitiesRequestParams {
    const ids: Array<Number> = [this.state.currentLinkModel.params.id];
    const gameCompetitionsId = [this.state.currentLinkModel.params.competitionKey?.split('-').last()];
    const withSeasons: Boolean = true;

    const selections = {
      [ROUTE_NAMES.competitionScores]: new EntitiesRequestParams(ids, null, null, null, withSeasons),
      [ROUTE_NAMES.competitorScores]: new EntitiesRequestParams(null, ids, null, null, withSeasons),
      [ROUTE_NAMES.game]: new EntitiesRequestParams(gameCompetitionsId, null, null, null, withSeasons),
    };

    const requestParams: EntitiesRequestParams = selections[this.state.currentLinkModel.name];

    return requestParams;
  }

  async action() {
    this.store.clearDataSource();

    const dataSource: EntitiesResponseDomainModel = await super.fetch();

    this.controller.action(ACTION_TYPES.populateData, {dataSource}).then(() => {
      this._triggerEntityContextChange();
    });

    return dataSource;
  }

  _triggerEntityContextChange() {
    this.websiteModuleState.entitiesContext.setCompetition(this.state.selectedCompetition);
    this.websiteModuleState.entitiesContext.setCompetitor(this.state.selectedCompetitor);
  }
}
